import * as React from "react";
import { colors } from "./styles";
import ValueInspector from "./ValueInspector";
export const History = React.memo(({ history, filterIgnored, }) => {
    return (React.createElement("ul", { style: {
            listStyleType: "none",
            padding: 0,
            color: colors.text,
            marginBottom: "0.5rem",
            fontSize: "14px",
        } }, history.map((item, index) => {
        if (item.type === "state") {
            return (React.createElement("li", { key: index, style: {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "0.25rem",
                } },
                React.createElement("span", { style: {
                        marginRight: "0.25rem",
                        fontSize: "12px",
                        color: colors.orange,
                    } }, "state"),
                React.createElement("span", { style: {
                        marginRight: "0.25rem",
                    } }, item.state.state),
                React.createElement(ValueInspector, { value: item.state, small: true })));
        }
        if (item.ignored && filterIgnored) {
            return null;
        }
        return (React.createElement("li", { key: index, style: {
                display: "flex",
                alignItems: "center",
                marginBottom: "0.25rem",
                opacity: item.ignored ? 0.5 : 1,
            } },
            React.createElement("span", { style: {
                    marginRight: "0.25rem",
                    fontSize: "12px",
                    color: colors.green,
                } }, "action"),
            React.createElement("span", { style: { marginRight: "0.25rem" } }, item.action.type),
            React.createElement(ValueInspector, { value: item.action, small: true })));
    })));
});
//# sourceMappingURL=History.js.map